import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('credits_applied'),
    reference: defineMessage('reference'),
    appliedTo: defineMessage('applied_to_1'),
    type: defineMessage('type_1'),
    dateDue: defineMessage('date'),
    currencyName: defineMessage('currency'),
    paymentAmount: defineMessage('payment'),
};
